import { routes } from "@/app/router/routes";
import type { MaxGrant, PageGrantItem } from "../types/permissionGroups";

function flattenRouteItems() {
    const items: { key: string; title: string }[] = [];

    for (const r of routes) {
        // 그룹 자체는 권한 대상으로 보기 애매해서 child만 대상으로
        if (r.children?.length) {
            for (const c of r.children) items.push({ key: c.id, title: c.name });
        } else {
            items.push({ key: r.id, title: r.name });
        }
    }

    // key 정렬 (Reflex와 동일한 느낌)
    items.sort((a, b) => a.key.localeCompare(b.key));
    return items;
}

export const PAGE_ITEMS_FOR_GRANT: PageGrantItem[] = flattenRouteItems().map((x) => {
    const maxGrant: MaxGrant = "writer"; // TODO: reader-only 페이지가 있으면 여기서 조건 분기
    return { key: x.key, title: x.title, maxGrant };
});

export const ALL_PAGES_ITEM: PageGrantItem = { key: "all", title: "모든 페이지", maxGrant: "writer" };

export const PAGE_KEYS_FOR_GRANT: string[] = ["all", ...PAGE_ITEMS_FOR_GRANT.map((x) => x.key)];